import './MarkingToolIcon.scss';
import { faBullseye, faDrawPolygon, faLongArrowAltRight, faPaintBrush, faSlash, faVectorSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../../../annotationTypes/models/annotationToolType';

export const MarkingToolIcon = ({ toolType, color }: { toolType: AnnotationToolType; color?: string }): ReactElement => (
  <>
    {toolType === AnnotationToolType.POINT && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faBullseye}
        css={{ color: `${color}` }}
      />
    )}
    {toolType === AnnotationToolType.RECTANGLE && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faVectorSquare}
        css={{ color }}
      />
    )}
    {toolType === AnnotationToolType.VECTOR && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faLongArrowAltRight}
        css={{ color }}
      />
    )}
    {toolType === AnnotationToolType.POLYLINE && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faSlash}
        css={{ color }}
      />
    )}
    {toolType === AnnotationToolType.POLYGON && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faDrawPolygon}
        css={{ color }}
      />
    )}
    {toolType === AnnotationToolType.ROTATEDRECTANGLE && (
      <FontAwesomeIcon
        className='marking-tool-icon rotated-rectangle'
        icon={faVectorSquare}
        css={{ color }}
      />
    )}
    {toolType === AnnotationToolType.BRUSH && (
      <FontAwesomeIcon
        className='marking-tool-icon'
        icon={faPaintBrush}
        css={{ color }}
      />
    )}
  </>
);
